import { FunctionComponent } from 'react';
import {AppEntry} from 'b302-frontend-library';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

import '@smastrom/react-rating/style.css'
import 'react-toastify/dist/ReactToastify.css';

import './styles/styles.scss';

import Content from './components/layout/Content';
import AuthContextProvider from './contexts/AuthContext';
import CountryContextProvider from './contexts/CountryContext';
import FavoritesContextProvider from './contexts/FavoritesContext';
import FormDeskApp from './config/App';

const app = new FormDeskApp();
const queryClient = new QueryClient();

const App: FunctionComponent = () => {

    return (
        <AppEntry app={app}>
            <QueryClientProvider client={queryClient}>
                <AuthContextProvider>
                    <CountryContextProvider>
                        <FavoritesContextProvider>
                            <Content />
                        </FavoritesContextProvider>
                    </CountryContextProvider>
                </AuthContextProvider>
            </QueryClientProvider>
        </AppEntry>
    );
};

export default App;
